import { render, staticRenderFns } from "./OnlyHeader.vue?vue&type=template&id=6679adf2&scoped=true"
import script from "./OnlyHeader.vue?vue&type=script&lang=js"
export * from "./OnlyHeader.vue?vue&type=script&lang=js"
import style0 from "./OnlyHeader.vue?vue&type=style&index=0&id=6679adf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6679adf2",
  null
  
)

export default component.exports